import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SITE } from '@/constants/site';

const NAV_ITEMS = [
  { to: '/', key: 'nav.home' },
  { to: '/about', key: 'nav.about' },
  { to: '/processing', key: 'nav.processing' },
  { to: '/contact', key: 'nav.contact' },
  { to: '/imprint', key: 'nav.imprint' },
];

export default function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="bg-accent-950 text-background-100">
      <div className="mx-auto w-full max-w-content px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center overflow-hidden rounded-md bg-background-50">
                <img
                  src="https://www.sn-metall.de/mediapool/126/1269216/resources/logo_609_112985789.jpg"
                  alt="S+N Blech- und Metallverarbeitungs GmbH"
                  className="h-full w-full object-contain p-0.5"
                />
              </span>
              <span className="flex flex-col leading-tight">
                <span className="font-heading text-base font-bold text-background-50">S+N Metall</span>
                <span className="text-[11px] uppercase tracking-[0.16em] text-background-200">Blechverarbeitung</span>
              </span>
            </div>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-background-200">{t('footer.tagline')}</p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold uppercase tracking-[0.16em] text-background-50">
              {t('footer.exploreLabel')}
            </h3>
            <ul className="mt-5 space-y-3">
              {NAV_ITEMS.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm text-background-200 transition-colors duration-200 hover:text-primary-300"
                  >
                    {t(item.key)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold uppercase tracking-[0.16em] text-background-50">
              {t('footer.contactLabel')}
            </h3>
            <ul className="mt-5 space-y-3 text-sm text-background-200">
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line mt-0.5 text-base text-primary-300" />
                <span>
                  {SITE.street}
                  <br />
                  {SITE.city}
                </span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-phone-line mt-0.5 text-base text-primary-300" />
                <a href={SITE.phoneHref} className="transition-colors duration-200 hover:text-primary-300">
                  {SITE.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-mail-line mt-0.5 text-base text-primary-300" />
                <a href={SITE.emailHref} className="transition-colors duration-200 hover:text-primary-300">
                  {SITE.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-background-50/15 pt-6 text-xs text-background-200 sm:flex-row sm:items-center sm:justify-between">
          <p>
            © {year} {SITE.name}. {t('footer.rights')}
          </p>
          <div className="flex items-center gap-5">
            <Link to="/imprint" className="transition-colors duration-200 hover:text-primary-300">
              {t('nav.imprint')}
            </Link>
            <Link to="/contact" className="transition-colors duration-200 hover:text-primary-300">
              {t('nav.contact')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}